// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__0mO4f","toggleNavigation":"Navigation_toggleNavigation__9bXOs"};